export const environment = {
  production: true,
  apiUrl: 'https://flycarapi-test.avis.co.il/api/kiosk',
  externalPaymentBaseUrl: 'https://flycarapi-test.avis.co.il/api/external/externalSite',
  firebase: {
    apiKey: 'AIzaSyBqNZM1kR4MsZwSMPOicUkFubXxF5Fov3Y',
    authDomain: 'flycartest-99477.firebaseapp.com',
    databaseURL: 'https://flycartest-99477.firebaseio.com',
    projectId: 'flycartest-99477',
    storageBucket: 'flycartest-99477.appspot.com',
    messagingSenderId: '354351551164',
    appId: '1:354351551164:web:b1080a9e0f6938f86076b9',
  },
  skipScan: false,
};